"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = ({ palette }) => styles_1.createStyles({
    connectorIcon: {
        color: palette.grey[100]
    }
});
//# sourceMappingURL=styles.js.map